module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq71-1365dccaa221fead61934aa76570afcc.jpg";